export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden text-[#33181F] pt-24 pb-10" style={{ background: "linear-gradient(180deg, rgba(255,142,83,0.34), rgba(214,71,142,0.30))" }}>
      <div className="orb w-[420px] h-[420px] bg-[#FF8E53] blur-[140px] opacity-35 -top-32 left-1/4" aria-hidden="true" />

      <div className="wrap relative">
        <p className="eyebrow text-[#E8431F] mb-8">Studio de production wellness</p>
        <h2 className="font-display font-bold text-[clamp(2.6rem,9vw,7.5rem)] leading-[0.98] tracking-[-0.03em]">
          Douceur Power
          <span className="font-serifit italic font-normal text-[#B5502F]"> Prod</span>
        </h2>

        <div className="mt-16 pt-8 border-t border-[#33181F]/15 flex flex-wrap items-center justify-between gap-6">
          <p className="eyebrow text-[#33181F]/50">Douceur Power Prod · 2026</p>
          <a
            href="mailto:alexia@ommymind.org"
            data-testid="footer-email"
            className="font-mono2 text-sm text-[#33181F]/70 hover:text-[#E8431F] transition-colors"
          >
            alexia@ommymind.org
          </a>
          <a
            href="tel:+33633341398"
            data-testid="footer-phone"
            className="font-mono2 text-sm text-[#33181F]/70 hover:text-[#E8431F] transition-colors"
          >
            06 33 34 13 98
          </a>
          <p className="eyebrow text-[#33181F]/50">douceurpower.com</p>
        </div>

        <p data-testid="footer-ommymind" className="mt-10 text-center font-serifit italic text-lg md:text-xl text-[#33181F]/70">
          Une agence portée par <span className="not-italic font-display font-semibold text-[#33181F]">Om My Mind</span> · Société à mission
        </p>
      </div>
    </footer>
  );
}
